import { FormProvider } from "react-hook-form";
import { useNewOrderForm } from "@/entities/new-order";
import { CreateOrderForm } from "@/widgets/create-order-form";
import { ImportOrderButton } from "@/features/new-order";

export const NewOrder = () => {
  const { methods, handleReset } = useNewOrderForm();

  return (
    <FormProvider {...methods}>
      <ImportOrderButton />
      <CreateOrderForm handleReset={handleReset} />
    </FormProvider>
  );
};
